import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a17d1e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-form-table",
  ref: "scFormTable"
};
const _hoisted_2 = {
  class: "move",
  style: {
    "cursor": "move"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_icon_d_caret = _resolveComponent("el-icon-d-caret");
  const _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
    data: $data.data,
    ref: "table",
    border: "",
    stripe: ""
  }, {
    empty: _withCtx(() => [_createTextVNode(_toDisplayString($props.placeholder), 1)]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "index",
      width: "50",
      fixed: "left"
    }, {
      header: _withCtx(() => [!$props.hideAdd ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        icon: "el-icon-plus",
        size: "small",
        circle: "",
        onClick: $options.rowAdd
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
      default: _withCtx(scope => [_createElementVNode("div", {
        class: _normalizeClass(['sc-form-table-handle', {
          'sc-form-table-handle-delete': !$props.hideDelete
        }])
      }, [_createElementVNode("span", null, _toDisplayString(scope.$index + 1), 1), !$props.hideDelete ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "danger",
        icon: "el-icon-delete",
        size: "small",
        plain: "",
        circle: "",
        onClick: $event => $options.rowDel(scope.row, scope.$index)
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)], 2)]),
      _: 1
    }), $props.dragSort ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      label: "",
      width: "50"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon_d_caret, {
        style: {
          "width": "1em",
          "height": "1em"
        }
      })])]),
      _: 1
    })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["data"])], 512);
}